<template lang="pug">
  y-bottom-sheet(v-model="showModal" inset scrollable max-width="600px" )
    v-card(flat tile)
      v-card-title.pa-4(:class="displaySymbol === '+' ? 'success100': 'basic200'")
        div.s1.primary500--text {{ item.title }}
        v-spacer
        div.p1(:class="displaySymbol === '+' ? 'success500--text': 'basic700--text'") {{ displaySymbol }} {{ item.amount | displayPrice }}
      v-card-text.pa-4
        div.d-flex
          div
            div.p2.primary400--text {{ displayReceiptId }}
            div.p2.primary400--text {{ item.type }}
          v-spacer
          div.text-right
            div.p2.primary400--text {{ displayDate }}
            div.p2.primary400--text {{ displayTime }}
        v-divider.basic300.my-3
        div.d-flex
          div.p2.primary500--text Payment method
          v-spacer
          div.p2.basic600--text {{ item.payment_method }}
        div.d-flex(v-if="item.type === 'Shipping' || item.type === 'Shipping Adjustment'")
          div.p2.primary500--text Orders
          v-spacer
          div.p2.basic600--text.text-right {{ displayOrders }}
      v-card-actions.pa-4
        v-btn.button-AA-medium(block color="textColorAccent" outlined :style="{'background-color': $vuetify.theme.themes[$theme].infoT08}" @click="$emit('viewReceipt')") View receipt
</template>

<script>
import { DateTime } from 'luxon'

export default {
  name: 'CreditHistoryBottomDetails',
  props: {
    open: {
      type: Boolean
    },
    item: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  computed: {
    showModal: {
      get () {
        return this.open
      },
      set (val) {
        return this.$emit('update:open', val)
      }
    },
    displayReceiptId () {
      return `#${DateTime.fromISO(this.item.created).toFormat('yyMMdd')}-${this.item.ref}`
    },
    displayDate () {
      return DateTime.fromISO(this.item.created).toFormat('dd MMM yyyy')
    },
    displayTime () {
      return DateTime.fromISO(this.item.created).toFormat('hh:mma')
    },
    displaySymbol () {
      return this.item.type === 'Wallet' ? '+' : '-'
    },
    displayOrders () {
      switch (this.item.type) {
        case 'Shipping':
          return this.item.data.ys_fulfilment.order_no.join(', ')

        case 'Shipping Adjustment':
          return this.item.data.ys_adjustment.lead_rid
      
        default:
          return null
      }
    }
  }
}
</script>

<style scoped>
</style>